module.exports = __webpack_public_path__ + "img/lk-icon.7976bf70.png";